var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBarcodeReader = function SvgBarcodeReader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "barcode_reader_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#barcode_reader_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 21q-1.5 0-2.387-1.162-.888-1.163-.513-2.588l1.8-6.8a4.2 4.2 0 0 1-1.363-1.425Q3 8.125 3 7q0-1.65 1.175-2.825T7 3h8q1.125 0 1.7.95.574.95.075 1.95l-2 4a2.2 2.2 0 0 1-.738.8q-.462.3-1.037.3h-2.025l-.275 1h.3q.424 0 .713.288.287.287.287.712v2q0 .424-.287.713A.97.97 0 0 1 11 16H9.65l-.75 2.8a2.96 2.96 0 0 1-1.075 1.588A2.92 2.92 0 0 1 6 21m0-2a.93.93 0 0 0 .6-.2 1.05 1.05 0 0 0 .35-.525L8.9 11H6.825l-1.8 6.75a.95.95 0 0 0 .175.863A.96.96 0 0 0 6 19M7 9h6l2-4H7q-.824 0-1.412.588A1.93 1.93 0 0 0 5 7q0 .824.588 1.413Q6.175 9 7 9m14.925-5.325L19.675 4.7a.7.7 0 0 1-.562.013.73.73 0 0 1-.413-.388.73.73 0 0 1-.025-.562.68.68 0 0 1 .375-.413l2.25-1.025a.72.72 0 0 1 .575-.012.724.724 0 0 1 .438.95.73.73 0 0 1-.388.412m-2.85 7a.77.77 0 0 1-.4-.425.7.7 0 0 1 0-.575.67.67 0 0 1 .425-.4.83.83 0 0 1 .6.025l2.25 1.05a.68.68 0 0 1 .375.413.73.73 0 0 1-.025.562.73.73 0 0 1-.413.388.7.7 0 0 1-.562-.013zM22.25 7.75h-2.5A.73.73 0 0 1 19 7a.73.73 0 0 1 .75-.75h2.5A.73.73 0 0 1 23 7a.73.73 0 0 1-.75.75"
  }))));
};
export default SvgBarcodeReader;